module.exports = __webpack_public_path__ + "static/media/pic8.24ce8b2f.jpg";